export type HapticPattern = 'tap' | 'correct' | 'wrong' | 'levelUp' | 'pop';

const PATTERNS: Record<HapticPattern, number[]> = {
  tap: [10],
  correct: [50],
  wrong: [30, 20, 30],
  levelUp: [50, 30, 80, 30, 120],
  pop: [15],
};

/**
 * Wrapper around navigator.vibrate that no-ops on unsupported devices.
 * Call on every meaningful interaction.
 */
export const haptic = (type: HapticPattern = 'tap'): void => {
  if (typeof navigator === 'undefined' || !navigator.vibrate) return;
  try {
    navigator.vibrate(PATTERNS[type] ?? PATTERNS.tap);
  } catch {
    // Some browsers reject vibrate() without a user gesture — silently ignore.
  }
};
